import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";

import { RootStateContext } from "../../states/root.state";
import { LegacyOrderProductImport } from "../../types/legacy";
import ExcelFileDrop from "../form/excelFileDrop.comp";
import ExcelFileInput from "../form/excelFileInput.comp";

export default function ImportLegacyOrderProduct() {
  const [excelData, setExcelData] = useState<LegacyOrderProductImport[] | null>(null);
  const { push } = useRouter();
  const { legacyOrderProductImportService } = useContext(RootStateContext);

  useEffect(() => {
    if (!excelData) return;

    legacyOrderProductImportService.send({ type: "SELECT_FILE", orderProducts: excelData });
    push("/import/legacyOrderProduct/list");

    // eslint-disable-next-line
  }, [excelData]);

  useEffect(() => {
    legacyOrderProductImportService.stop();
    legacyOrderProductImportService.start();

    // eslint-disable-next-line
  }, []);

  return (
    <section data-type="section" className="space-y-4">
      <h2>Legacy OrderProduct Import</h2>
      <ExcelFileDrop setExcelData={setExcelData} />
      <ExcelFileInput setExcelData={setExcelData} />
    </section>
  );
}
